import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type BulkDeleteOnboardingProcessStepsResponse = ClientInferResponseBody<
  typeof contract.onboardingProcessSteps.bulkDelete,
  200
>;

export const bulkDeleteOnboardingProcessStepsApi = async (
  ids: string[],
): Promise<BulkDeleteOnboardingProcessStepsResponse> => {
  const response = await api.onboardingProcessSteps.bulkDelete.mutation({
    body: { ids },
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError(
    "Failed to bulk delete onboarding process steps",
    response.status,
    response.body,
  );
};
